import React from 'react';
import { Button, Typography, Container, Paper } from '@material-ui/core';
import { Link } from '@reach/router';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
    textAlign: 'center',
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: 60,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

const MercadopagoFailure = ({ orderId }) => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="sm" className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h4" gutterBottom>
          ¡Error en el pago!
        </Typography>
        <Typography variant="subtitle1">
          Hubo un problema al procesar tu pago. Por favor, inténtalo de nuevo.
        </Typography>
        <Button
          component={Link}
          to={`/carrito`}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          Volver al carrito
        </Button>
      </Paper>
    </Container>
  );
};

export default MercadopagoFailure;
